import React from 'react';
import { Badge } from './styles';

const AmbassadorBadge: React.FC = () => <Badge>Exclusivo embaixador</Badge>;

export default AmbassadorBadge;
